export const NAV = [
  { key: "nav.home", to: "/" },
  {
    key: "nav.about",
    children: [
      { key: "nav.aboutGpu", to: "/about" },
      { key: "nav.objectives", to: "/objectives" },
      { key: "nav.committees", to: "/committees" },
      { key: "nav.districts", to: "/districts" },
      { key: "nav.institutional", to: "/institutional-engagement" },
      { key: "nav.ethics", to: "/code-of-ethics" },
    ],
  },
  {
    key: "nav.membership",
    children: [
      { key: "nav.membership", to: "/membership" },
      { key: "nav.memberBenefits", to: "/member-benefits" },
      { key: "nav.memberRegistration", to: "/member-registration" },
      { key: "nav.declaration", to: "/membership-declaration" },
    ],
  },
  {
    key: "nav.vendors",
    children: [
      { key: "nav.vendorNetwork", to: "/vendor-network" },
      { key: "nav.vendorRegistration", to: "/vendor-registration" },
    ],
  },
  {
    key: "nav.protection",
    children: [
      { key: "nav.gpuProtection", to: "/gpu-protection" },
      { key: "nav.safeTrade", to: "/safe-trade-network" },
      { key: "nav.antiCounterfeit", to: "/anti-counterfeit" },
    ],
  },
  {
    key: "nav.resources",
    children: [
      { key: "nav.knowledge", to: "/resources" },
      { key: "nav.downloads", to: "/downloads" },
      { key: "nav.faq", to: "/faq" },
    ],
  },
  {
    key: "nav.news",
    children: [
      { key: "nav.news", to: "/news" },
      { key: "nav.events", to: "/events" },
      { key: "nav.media", to: "/media" },
    ],
  },
  { key: "nav.verify", to: "/verify" },
  { key: "nav.contact", to: "/contact" },
];
